/* eslint-disable no-param-reassign */
import { APIStatusEnum } from './reloadData/APIStatusEnum';

export type HandleWaitingCallFinished<Res> = {
  status: APIStatusEnum;
  response?: Res;
};
type WaitingCallGeneric<Res> = {
  waitingAPICall: () => Promise<Res & { status: APIStatusEnum }>;
  count?: number;
  // Asked before every retry and before the result is handed over, so a caller can walk away.
  isCancelled?: () => boolean;
  handleWaitingFirstCallFinished?: (params: HandleWaitingCallFinished<Res>) => void;
  handleWaitingCallFinished: (params: HandleWaitingCallFinished<Res>) => void;
};

export const waitingCallGeneric = <Res>({
  waitingAPICall,
  count = 0,
  isCancelled,
  handleWaitingFirstCallFinished,
  handleWaitingCallFinished,
}: WaitingCallGeneric<Res>) => {
  if (isCancelled?.()) return;

  if (count === 60) {
    // setAPIStatus(APIStatusEnum.READY);
    handleWaitingCallFinished({ status: APIStatusEnum.READY });
  } else {
    const timeoutMs = count === 0 ? 0 : 1000;
    setTimeout(() => {
      // A retry scheduled before the caller walked away must not still go out.
      if (isCancelled?.()) return;

      waitingAPICall()
        .then((response) => {
          if (isCancelled?.()) return;

          if (response) {
            if (response.status === APIStatusEnum.WAIT || response.status === APIStatusEnum.RESYNC) {
              if (count === 0 && handleWaitingFirstCallFinished) {
                handleWaitingFirstCallFinished({
                  status: APIStatusEnum.WAIT,
                  response,
                });
              }
              count += 1;
              waitingCallGeneric<Res>({
                waitingAPICall,
                count,
                isCancelled,
                handleWaitingFirstCallFinished,
                handleWaitingCallFinished,
              });
            } else {
              // setAPIStatus(response.status);
              handleWaitingCallFinished({
                status: response?.status || APIStatusEnum.READY,
                response,
              });
            }
          } else {
            count += 1;
            waitingCallGeneric<Res>({
              waitingAPICall,
              count,
              isCancelled,
              handleWaitingFirstCallFinished,
              handleWaitingCallFinished,
            });
          }
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.log(error);
          count += 1;
          waitingCallGeneric<Res>({
            waitingAPICall,
            count,
            isCancelled,
            handleWaitingFirstCallFinished,
            handleWaitingCallFinished,
          });
        });
    }, timeoutMs);
  }
};
